import { shallowRef } from 'vue'

export const routeChunkError = shallowRef<string | null>(null)

const CHUNK_LOAD_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
  'loading chunk',
  'chunkloaderror',
  'unable to preload css',
] as const

export const isRouteChunkLoadError = (error: unknown): boolean => {
  if (error instanceof Error && error.name === 'ChunkLoadError') {
    return true
  }

  const message = (error instanceof Error ? error.message : String(error)).toLowerCase()
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
}

export const clearRouteChunkError = (): void => {
  routeChunkError.value = null
}

export const setRouteChunkError = (error: unknown): void => {
  const message = error instanceof Error ? error.message : String(error)
  routeChunkError.value = message || 'Failed to load page'
}
